import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './style/lecture-navigation-menu.scss';

export const LetureNavigationMenu = () => {
    const [isOpen, setIsOpen] = useState(true);
    const location = useLocation();
    const currentPageId = new URLSearchParams(location.search).get('pageId');

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`lecture-navigation-menu ${isOpen ? 'open' : 'collapsed'}`}>
            <div className="lecture-navigation-menu--header">
                {isOpen ? 'Learn french A1' : ''}
                <button className="close-btn" onClick={toggleMenu}>
                    {isOpen ? '×' : '☰'}
                </button>
            </div>

            {isOpen && (
                <>
                    <div className="lecture-navigation-menu--unit">
                        <div className="lecture-navigation-menu--unit-number">Unit 1</div>
                        <div className="lecture-navigation-menu--unit-title">Introducing Yourself</div>
                        <ul className="lecture-navigation-menu--lectures">
                            <li className={currentPageId === 'M6DKHFL2KUK' ? 'active' : ''}>
                                <a href="/lecture?cours=learnfrench&pageId=M6DKHFL2KUK">Saying hello and goodbye</a>
                            </li>
                            <li className={currentPageId === '46DKHFL2KUK' ? 'active' : ''}>
                                <a href="/lecture?cours=learnfrench&pageId=46DKHFL2KUK">Introducing yourself: name, age, nationality</a>
                            </li>
                            <li className={currentPageId === '26DAHFL2KUK' ? 'active' : ''}>
                                <a href="/lecture?cours=learnfrench&pageId=26DAHFL2KUK">Asking and giving personal info</a>
                            </li>
                        </ul>
                    </div>

                    <div className="lecture-navigation-menu--unit">
                        <div className="lecture-navigation-menu--unit-number">Unit 2</div>
                        <div className="lecture-navigation-menu--unit-title">Daily Life</div>
                        <ul className="lecture-navigation-menu--lectures">
                            <li className={currentPageId === '36DKHFL2KUK' ? 'active' : ''}>
                                <a href="/lecture?cours=learnfrench&pageId=36DKHFL2KUK">Talking about your routine</a>
                            </li>
                        </ul>
                    </div>
                </>
            )}
        </div>
    );
};